export const memberBindingKinds = ['wechat', 'taobao'] as const
export type MemberBindingKind = (typeof memberBindingKinds)[number]

export const memberBindingConfigs = {
  wechat: {
    title: '解绑微信',
    queryEndpoint: '/admin/getErrorWxInfo',
    submitEndpoint: '/admin/clearWxBind',
    actionLabel: '解绑微信',
  },
  taobao: {
    title: '淘宝授权处理',
    queryEndpoint: '/admin/getErrorTaobao',
    submitEndpoint: '/admin/clearTaobaoInfo',
    actionLabel: '清除淘宝授权',
  },
} as const
